import Vue from 'vue'
import Vuex from 'vuex'

import Cookies from 'js-cookie';
import createPersistedState from "vuex-plugin-persistedstate";
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userData: null,
    cartNum: 0,
    searchKey: [],
  },
  mutations:{
    setUserData(state, userData ){
      if(!userData){
        Cookies.remove('VUEX-PERSISTEDSTATE');
      }else{
        Cookies.set('VUEX-PERSISTEDSTATE', JSON.stringify({tokEn: userData.tokEn,memId: userData.memId,authFlag: userData.authFlag , authSrc : userData.authSrc}));
      }
      state.userData = userData;
    },
    setCartNum(state, num){
      state.cartNum = num > 99 ? '99+' : num;
    },
    setSearchKey(state, keys){
      state.searchKey = keys;
    }
  },
  getters:{
    getUserData(state){
      if(state.userData){
        return state.userData
      }
      let userDataJson = Cookies.get('VUEX-PERSISTEDSTATE');
      if(userDataJson){
        return JSON.parse(userDataJson);
      }
      return null;
    },
    getCartNum(state){
      return state.cartNum;
    },
    getSearchKey(state){
      return state.searchKey;
    }
  },
  plugins: [createPersistedState()],
});

export default store;